export const getBaseUrl = () =>
  document?.getElementsByTagName('base')?.[0]?.href || '';
